export default function replaceSpecialChars(str: string, replacer = " ") {
  return str.replace(/[^A-Za-z0-9]/g, replacer);
}
